import { observer } from "mobx-react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    useMediaQuery,
    useTheme, Input
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LocalizedString } from "../../../services/general/models";
import { changeEventHandlerDecorator, localize } from "../../libs";
import style from '../../../modules/menu/pages/menuEditor/style.module.css'
import { useStores } from "../../../hooks";


const TranslationEditor = () => {
    const { t } = useTranslation(['menu', 'general']);
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const { translationStore } = useStores();
    const open = translationStore.translationEditorForm.open;
    const [value, setValue] = useState<LocalizedString>(translationStore.value || {});
    const { generalStore } = useStores();
    const { availableLanguages } = translationStore;

    useEffect(() => {
        setValue(translationStore.value || {});
    }, [translationStore.value])


    const closeForm = () => {
        translationStore.closeTranslationEditorForm()
    };


    const getLangValueSetter = (locale: string) => {
        return (v: string) => {
            setValue({
                ...value,
                [locale]: v
            });
        }
    }


    const getLangValue = (locale: string) => {
        return value[locale] || ""
    }

    //if (!ordersStore.current) return;
    //if (!menuStore.currentMenu) return;




    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">
                {t("menu:translationEdit")}
            </DialogTitle>
            <DialogContent>
                <div>
                    {availableLanguages.length > 0 &&
                        availableLanguages.map(locale => {
                            return <FormControl fullWidth margin={"normal"} key={locale}>

                                <Input
                                    value={getLangValue(locale)}
                                    rowsMax={translationStore.numberOfLines}
                                    multiline={translationStore.numberOfLines > 1}
                                    onChange={changeEventHandlerDecorator(getLangValueSetter(locale))}
                                    startAdornment={<div>
                                        {locale === 'ru' && <span className={style.flags}>&#x1F1F7;&#x1F1FA;</span>}
                                        {locale === 'en' && <span className={style.flags}>&#x1F1FA;&#x1F1F8;</span>}
                                        {locale === 'it' && <span className={style.flags}>&#127470;&#127481;</span>}
                                        {locale === 'zh' && <span className={style.flags}>&#127464;&#127475;</span>}
                                    </div>
                                    }
                                />

                                <Button
                                    onClick={async (e: React.MouseEvent) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        const res = await translationStore.autoTranslate({
                                            sourceLang: generalStore.locale.id,
                                            targetLang: locale,
                                            text: value[generalStore.locale.id]
                                        });
                                        setValue({
                                            ...value,
                                            [locale]: res.data.translatedText
                                        });
                                    }}
                                    color="primary">
                                    {t("menu:autoTranslation")}
                                </Button>
                            </FormControl>;
                        })}

                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        translationStore.closeTranslationEditorForm();
                    }}
                    color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        translationStore.newValue(value);
                        translationStore.closeTranslationEditorForm();
                    }}
                >
                    {t("general:save")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default observer(TranslationEditor)
